export const DEALS_SECTION_ID = 'special-offers-section';
export const ABOUT_ME_SECTION_ID = 'about-me-section';
export const PRICING_SECTION_ID = 'pricing-section';
export const FEATURES_SECTION_ID = 'features-section';
export const DESCRIPTION_SECTION_ID = 'supplier-description-section';
export const REAL_WEDDINGS_SECTION_ID = 'real-weddings-section';
export const REVIEWS_SECTION_ID = 'supplier-testimonials';
export const LOCATION_SECTION_ID = 'supplier-location-section';
export const VISIT_VENUE_SECTION_ID = 'supplier-visit-venue-section';
export const SHOWROUNDS_CALENDAR_SECTION_ID = 'supplier-showrounds-calendar-section';
export const PLAN_A_VISIT_SECTION_ID = 'supplier-plan-a-visit-section';
export const PLAN_A_VISIT_SECTION_ID_MOCK = 'supplier-plan-a-visit-section-mock';
export const FAQ_AWARDS_PREFERRED_SUPPLIERS_SECTION_ID = 'faq-awards-preferred-suppliers-section';
export const PHOTO_SECTION_ID = 'supplier-photo-section';
export const MANAGER_MESSAGE_SECTION_ID = 'manager-message-section';
export const VIEW_PROFILE_SECTION_ID = 'view-profile-section';
export const WEDDING_FAIRS_SECTION_ID = 'wedding-fairs-header';
export const CAROUSEL_SECTION_ID = 'carousel-section';
export const INFO_SECTION_ID = 'info-section';
export const VENUE_HIGHLIGHTS_SECTION_ID = 'key-info-section';
export const PRICE_ESTIMATE_WIDGET_SECTION_ID = 'price-estimate-widget-section';
export const BROCHURE_SECTION_ID = 'brochure-section';
export const STICKY_NAVIGATION_BAR_ID = 'sticky-navigation-bar';
export const PHOTO_HIGHLIGHTS_SECTION_ID = 'highlights-section';
export const VENUEREX_SECTION_ID = 'venuerex-section';
export const INSTAGRAM_SECTION_ID = 'instagram-section';
export const RECOMMENDED_PHOTOGRAPHER_SECTION_ID = 'recommended-photographer-section';
export const BENEFITS_SECTION_ID = 'benefits-section';
export const ABOVE_REQUEST_BUTTON_ID = 'above-request-button';

// subsections of FAQ_AWARDS_PREFERRED_SUPPLIERS_SECTION_ID
export const FAQ_SECTION_ID = 'faq-section';
export const AWARDS_SECTION_ID = 'awards-section';
export const PREFERRED_SUPPLIERS_SECTION_ID = 'preferred-suppliers-section';

// subsections of DEALS_SECTION_ID
export const SPECIAL_OFFERS_HEADER_ID = 'special-offers-header';
export const SPECIAL_OFFER_POPUP_ID = 'special-offer-popup-inner';

// supplier finding experience compact profile
export const COMPACT_LIST_GALLERY = 'list-gallery';
export const COMPACT_MASONRY_GALLERY = 'masonry-gallery';
